import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import {ReportSectionHeader} from "../SectionHeader";


const CoverageSufficiencyComponent = (props) => (

    <div>
        <ReportSectionHeader>
			{"Estimated Potential Rule 10b-5 Loss"}
        	
        </ReportSectionHeader>
        <ReportTable
            settings={[
                {
                    header: '',
                    accessor: 'name'
                },
                {
                    header: '',
                    accessor: 'value',
                    dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true,
                    blockNull: true
                }
            ] 
           }
            data={props.sufficiencyData}
            name={"sufficiencyData"}
           
        />

    </div>
);


export default CoverageSufficiencyComponent;


// WEBPACK FOOTER //
// ./src/common/components/CoverageSufficiency/CoverageSufficiencyComponent.js